<template>
  <div class="app">
    <back-route-hdr :back-mode="'static'"></back-route-hdr>
    <!-- 日程 -->
    <div class="mt-schedule mar-top-10 pad-btm-10 van-calendar" :class="'mt-'+schType">
      <div class="van-calendar__header">
        <div class="mar-hor pad-top pad-btm-10 flex-wrap-between">
          <span class="text-lg">{{curDateCN}}</span>
          <div class="van-stepper">
            <van-button type="default" size="small" @click="handleSchedule('minus')">
              <i class="fa fa-angle-double-left"></i>
            </van-button>
            <van-button type="default" size="small" @click="handleSchedule()" class="pad-hor">今天</van-button>
            <van-button type="default" size="small" @click="handleSchedule('plus')">
              <i class="fa fa-angle-double-right"></i>
            </van-button>
          </div>
        </div>
        <div class="van-calendar__weekdays">
          <span class="van-calendar__weekday">日</span>
          <span class="van-calendar__weekday">一</span>
          <span class="van-calendar__weekday">二</span>
          <span class="van-calendar__weekday">三</span>
          <span class="van-calendar__weekday">四</span>
          <span class="van-calendar__weekday">五</span>
          <span class="van-calendar__weekday">六</span>
        </div>
      </div>
      <div class="van-calendar__body">
        <div class="van-calendar__month">
          <div role="grid" class="van-calendar__days">
            <div class="van-calendar__day" v-for="(date, idx) in calendarDayOptions"
                 :class="date.isToday?'today':''"
                 :key="date.value" @click="date.value && (selectedDayVal=date.value)">
              <span :class="date.value===selectedDayVal ?'van-calendar__selected-day':''">
                {{date.isToday ? '今天' : date.label}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center text-lg text-primary" @click="handleSchType">
        <span><i class="fa" :class="isWeek ? 'fa-angle-double-down' : 'fa-angle-double-up'"></i></span>
      </div>
    </div>

    <div class="mt-schedule-ctn mar-ver bg-white" :class="meetingData.length ? '' : 'flex-center'">
      <div v-if="loading" class="text-center">
        <van-loading size="24px" vertical color="#2D69E0">加载中...</van-loading>
      </div>
      <div v-else-if="!meetingData.length">
        <empty-notice :image="'meeting'" :desc="'暂无会议~'"></empty-notice>
        <div v-show="showReserveBtn" class="text-center mar-top">
          <van-button type="primary" plain size="small"
                      @click="pushPages()">新建预约
          </van-button>
        </div>
      </div>
      <div v-else>
        <meeting-list-cell v-for="(ele, idx) in meetingList" :key="idx"
                           :formatted-mt="ele" @click-cell="pushPages(ele)">
        </meeting-list-cell>
      </div>
    </div>

  </div>
</template>

<script>
  import {commonConfig, momentFormat} from "../../../../config/common";
  import {getStorage, StorageKey} from "../../../../tools/storage";
  import {meeting} from "../../../../server";
  import {
    formatMListDoc,
    sortMeeting,
    setSchReserveDate,
    joinMtInReactNative,
  } from "../../../../tools/utils";
  import MeetingListCell from "../../components/MeetingListCell"
  import routerMeta from "../../router/routerMeta";

  const schTypes = {
    week: "week",
    month: "month",
  };
  export default {
    components: {
      MeetingListCell,
    },
    data() {
      return {
        todayVal: moment().format(momentFormat.dateFormatDaySlant),
        firstDate: new Date(),
        selectedDayVal: moment().format(momentFormat.dateFormatDaySlant),
        schType: schTypes.month,
        meetingData: [],
        loading: true,
      }
    },
    computed: {
      isWeek() {
        return this.schType === schTypes.week
      },
      calendarDayOptions() {
        const options = [];
        const cMonth = this.firstDate.getMonth() + 1 + '';

        let dayIdx = 0;
        let days = this.isWeek ? 7 : Number(moment(this.firstDate).endOf('month').format('D'));
        while (dayIdx < days) {
          const formattedDate = moment(this.firstDate).add(dayIdx, 'day');
          const value = formattedDate.format(momentFormat.dateFormatDaySlant);
          const label = formattedDate.format('D');
          const month = formattedDate.format('M');
          // console.log({cMonth, month});
          options.push((this.isWeek || cMonth === month) ? {
            label,
            value,
            isToday: this.todayVal === value
          } : {});
          dayIdx++
        }
        // 补充月初周数据
        const wkDay = this.firstDate.getDay();
        let emptyOpts = [];
        if (!this.isWeek && wkDay) {
          let emptyIdx = 0;
          while (emptyIdx < wkDay) {
            emptyOpts.push({});
            emptyIdx++
          }
        }
        return emptyOpts.concat(options)
      },
      selectedDate() {
        return new Date(this.selectedDayVal)
      },
      curDateCN() {
        return moment(this.selectedDate).format(momentFormat.dateFormatMonthCN)
      },
      meetingList() {
        const list = this.meetingData.map(ele => formatMListDoc(ele, this, this.selectedDate));
        return list.sort(sortMeeting)
      },
      showReserveBtn() {
        const diff = moment(this.selectedDate).diff(moment(), 'day');
        // console.log(diff);
        return diff >= 0
      },
    },
    watch: {
      selectedDate(val) {
        // console.log(moment(val).format('YYYY-MM-DD'));
        this.getMeetings(val);
        this.setFirstDate()
      },
    },
    created() {
      const schFilter = this.$store.state.scheduleFilter;
      if (schFilter) {
        const {schType, selectedDayVal} = schFilter;
        this.schType = schType || schTypes.month;
        this.selectedDayVal = selectedDayVal;
        this.$store.commit('setSchFilter', null);  // 清除
      }
      this.getMeetings(this.selectedDate);
      this.setFirstDate()
    },
    mounted() {
      this.getHeight(54)
    },
    methods: {
      // 设置初始时间
      setFirstDate() {
        let subtractDays = 0;
        if (this.isWeek) {
          subtractDays = this.selectedDate.getDay();
        } else {
          subtractDays = this.selectedDate.getDate() - 1;
        }
        // console.log('subtractDays', subtractDays);
        this.firstDate = moment(this.selectedDate).subtract(subtractDays, 'day').toDate();
      },
      //动态监听高度
      getHeight(num) {
        let h = window.innerHeight
        document.querySelector(".mt-schedule-ctn").style.height = 'auto'
      },
      handleSchType() {
        if (this.isWeek) {
          this.getHeight()
          this.schType = schTypes.month
        } else {
          document.querySelector(".mt-schedule-ctn").style.height = 72.5 + 'vh'
          this.schType = schTypes.week
        }
        this.setFirstDate()
      },
      handleSchedule(type) {
        const unit = this.schType;
        switch (type) {
          case 'minus':
            this.selectedDayVal = moment(this.selectedDate).subtract(1, unit).startOf(unit).format(momentFormat.dateFormatDaySlant);
            break;
          case 'plus':
            this.selectedDayVal = moment(this.selectedDate).add(1, unit).startOf(unit).format(momentFormat.dateFormatDaySlant);
            break;
          default:
            this.selectedDayVal = this.todayVal
        }
      },
      getMeetings(date) {
        this.loading = true;
        const userId = getStorage(StorageKey.userId);
        const filter = {
          createdBy: userId,
          userId: userId,
          ccUserId: userId,
          getIsUserCheckin: true,
          date: (date || moment()).valueOf()
        };
        // 查询会议
        meeting.queryList(this, {queryFilter: filter}).then(({searchMeeting: data = {}}) => {
          this.loading = false;
          this.meetingData = (data.meetingEdges || []);
        }).catch(err => {
          this.loading = false;
          // console.log(err);
          vtToast(err.message)
        })
      },
      checkMtStatus(mDoc) {
        return !commonConfig.endedStatus.includes(mDoc.status)
      },
      pushPages(mDoc) {
        // console.log(mDoc)
        this.$store.commit('setSchFilter', {
          schType: this.schType,
          selectedDayVal: this.selectedDayVal
        });
        if (mDoc && mDoc.mid) {
          this.$router.push({name: routerMeta.meetingDetailFromSch.name, params: {mid: mDoc.mid}})
        } else {
          setSchReserveDate.call(this, this.selectedDate);
          this.$router.push({name: routerMeta.meetingReserveFromSch.name})
        }
      },
      joinMeeting(evt, tlcInfo) {
        // console.log(tlcInfo)
        evt.stopPropagation();  // 阻止冒泡
        joinMtInReactNative(tlcInfo);
      },
    }
  }
</script>

<style lang="less" scoped>
  .app {
    display: flex;
    flex-wrap: wrap;
    height: 100vh;
  }

  .mt-month {
    .van-calendar__day {
      height: 40px !important;
      font-size: 15px !important;;
    }
  }

  .pad-btm-10 {
    padding: 2% !important;
  }

  .van-calendar {
    height: auto;
  }

  .van-calendar[data-v-4aae5694] {
    width: 100%;
  }

  .van-calendar__month {
    height: auto;
  }

  .mar-top-10 {
    margin-top: 2% !important;
    width: 100% !important;
  }

  .mar-ver {
    margin-top: 3% !important;
    margin-bottom: 2% !important;
  }

  .mt-schedule-ctn {
    width: 100%;
    min-height: 50%;
    max-height: 80%
  }

  @media only screen and (device-width: 320px)and(device-height: 568px) {
    /deep/ .van-empty__image {
      height: 112px !important;
    }

    .mt-schedule-ctn {
      height: 228px;
    }
  }
</style>
